import { UpdateAudioCloudFileRequest } from "../../../../../../../../common/api/master-api/cloud-files/update/UpdateAudioCloudFileRequest";
import { RequestBuilderParams } from "./RequestBuilderParams";

export const buildUpdateAudioCloudFileRequest = ({
    cloudFileId,
    contentRef,
    selectedLanguages
}: RequestBuilderParams): UpdateAudioCloudFileRequest => {
    const soundtrackLanguageId = selectedLanguages.soundtrackLanguageId ?? undefined;

    return {
        cloudFileId,
        contentDetails: contentRef,
        soundtrackLanguageId
    };
};
